import React, { Component } from "react";
import { connect } from "react-redux";
import { PropTypes } from "prop-types";
import { Segment, Header } from "semantic-ui-react";

import UserDetailsRequestForm from "../../components/sentry/UserDetailsRequestForm.jsx";
import UserDetailsRequestFormResult from "../../components/sentry/UserDetailsRequestFormResult.jsx";
import LinkWithReset from "../../components/utils/LinkWithReset.jsx";

import {
  usernameRequest,
  resetUsernameStore
} from "../../state/reducers/account/accountActions.js";
import { selectCopy } from "../../state/reducers/locale/copySelector.js";

class UsernameRequest extends Component {
  static propTypes = {
    isFetching: PropTypes.bool.isRequired,
    isSuccess: PropTypes.bool.isRequired,
    usernameRequest: PropTypes.func.isRequired,
    resetUsernameStore: PropTypes.func.isRequired,
    copyKey: PropTypes.string.isRequired,
    copy: PropTypes.func.isRequired
  };

  static defaultProps = {
    copyKey: "sentry.username_recovery"
  };

  constructor(props) {
    super(props);

    this.props.resetUsernameStore();
  }

  // -- HANDLERS -- //

  onSubmit = values => {
    this.props.usernameRequest(values);
  };

  // -- RENDER -- //

  renderForm = () => {
    const { isFetching, isSuccess, copyKey } = this.props;

    if (isSuccess) {
      return (
        <UserDetailsRequestFormResult copyKey="sentry.username_recovery_result" />
      );
    }

    return (
      <UserDetailsRequestForm
        isFetching={isFetching}
        copyKey={copyKey}
        onSubmit={this.onSubmit}
      />
    );
  };

  render() {
    const { copyKey, copy } = this.props;

    return (
      <div className="sentry-form">
        <Header as="h3" inverted>
          {copy(`${copyKey}.title`)}
        </Header>
        <Segment padded textAlign="left">
          {this.renderForm()}
        </Segment>
        <footer>
          <LinkWithReset to="/">{copy(`${copyKey}.login_cta`)}</LinkWithReset>
        </footer>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  isFetching: state.username.isFetching,
  isSuccess: state.username.isSuccess,
  copy: selectCopy(state)
});

const mapDispatchToProps = dispatch => ({
  usernameRequest: data => dispatch(usernameRequest(data)),
  resetUsernameStore: () => dispatch(resetUsernameStore())
});

export default connect(mapStateToProps, mapDispatchToProps)(UsernameRequest);
